<template>
    <div class="flex flex-col gap-2">
        <slot />
    </div>
</template>
